export default __webpack_public_path__ + "static/media/login.52a3f422.png";